import { type BreakpointName } from "./types";

export const BREAKPOINT_WIDTH_XS = 800;
export const BREAKPOINT_WIDTH_XXS = 0;

export const BREAKPOINT_COLS_XS = 4;
export const BREAKPOINT_COLS_XXS = 1;

export const BREAKPOINT_WIDTHS: Record<BreakpointName, number> = {
  xs: BREAKPOINT_WIDTH_XS,
  xxs: BREAKPOINT_WIDTH_XXS,
};

export const BREAKPOINT_COLS: Record<BreakpointName, number> = {
  xs: BREAKPOINT_COLS_XS,
  xxs: BREAKPOINT_COLS_XXS,
};
